import { gql, useMutation } from "@apollo/client";

const GenChartsScreenshotsMutation = gql`
  mutation genChartsScreenshots($input: GenChartsScreenshotsInput!) {
    genChartsScreenshots(input: $input) {
      screenshots {
        chartID
        screenshotUrl
      }
    }
  }
`;

export const useGenChartsScreenshotsMutation = () =>
  useMutation<
    {
      genChartsScreenshots: {
        screenshots: [
          {
            chartID: string;
            screenshotUrl: string;
          }
        ];
      };
    },
    {
      input: {
        chartsIDs: string[];
      };
    }
  >(GenChartsScreenshotsMutation);
